"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _modal = require("./modal");
var _form_submit_buttons = _interopRequireDefault(require("../form_submit_buttons"));
var _excluded = ["id", "className", "children", "extraActions", "onSubmit"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ModalWithSubmitActions = function ModalWithSubmitActions(props) {
  var id = props.id,
    className = props.className,
    children = props.children,
    extraActions = props.extraActions,
    onSubmit = props.onSubmit,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/React.createElement(_modal.Modal, null, /*#__PURE__*/React.createElement(_modal.Container, (0, _extends2["default"])({
    id: id,
    className: className
  }, restProps), /*#__PURE__*/React.createElement(_modal.Header, restProps), /*#__PURE__*/React.createElement(_modal.Content, (0, _extends2["default"])({}, restProps, {
    draggable: false
  }), children), /*#__PURE__*/React.createElement(_modal.Footer, null, /*#__PURE__*/React.createElement(_form_submit_buttons["default"], (0, _extends2["default"])({
    onSubmit: onSubmit,
    onCancel: props.onCancel || props.closeModal
  }, restProps, {
    compact: true
  }), extraActions))));
};
var _default = exports["default"] = ModalWithSubmitActions;
ModalWithSubmitActions.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'md',
  displayXIcon: true,
  dividers: true,
  draggable: true
};